import LoyaltyOnboardingDesktop from "components/organisms/LoyaltyOnboardingDesktop";
import { useLoyaltyStore } from "stores/loyalty";

export const LoyaltyOnboardingDesktopContainer = () => {
  const onboardingIsOpen = useLoyaltyStore((state) => state.isOpenOnboarding);
  const handleOpenOnboarding = useLoyaltyStore(
    (state) => state.setIsOpenOnboarding,
  );

  const handleCloseOnboarding = () => {
    handleOpenOnboarding(false);
  };

  const handleEndOnboard = () => {
    handleOpenOnboarding(false);
  };

  return (
    <LoyaltyOnboardingDesktop
      isProgress={onboardingIsOpen}
      onEndWatchOnboard={handleEndOnboard}
      onCloseOnboard={handleCloseOnboarding}
    />
  );
};
